import React, { ReactNode } from 'react';
import styled from 'styled-components';

interface AspectRatioProps {
  width: number;
  height: number;
  children: ReactNode;
}

export const AspectRatioBox = styled.div`
  height: 0;
  overflow: hidden;
  padding-top: ${({ width, height }: AspectRatioProps) =>
    (100 * height) / width}%;
  position: relative;

  @media print {
    padding-top: 0;
    height: auto;
  }
`;

const AspectRatioInner = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;

  @media print {
    position: relative;
  }
`;

const AspectRatio = ({ width, height, children }: AspectRatioProps) => (
  <AspectRatioBox width={width} height={height}>
    <AspectRatioInner>{children}</AspectRatioInner>
  </AspectRatioBox>
);

export default AspectRatio;
